import { useTheme } from "context/ThemeContext";
import { hexToRgb, lightenColor } from "utils/colors.utils";

/**
 * Hook to get dashboard theme values.
 *
 * @returns {{
 * lineChart: {lineColor: string},  // Configuration for line charts
 * barChart: {barColor: string},    // Configuration for bar charts
 * primaryColor_01: string,         // Lightened primary color (HEX or RGB string, based on lightenColor implementation)
 * primaryColor_02: string,         // Primary color with 0.2 opacity (RGBA string)
 * primaryColor_03: string,         // Primary color with 0.3 opacity (RGBA string)
 * primaryColor_04: string,         // Primary color with 0.4 opacity (RGBA string)
 * primaryColor_05: string,         // Primary color with 0.5 opacity (RGBA string)
 * primaryColor_06: string,         // Primary color with 0.6 opacity (RGBA string)
 * primaryColor_07: string,         // Primary color with 0.7 opacity (RGBA string)
 * primaryColor: string,            // Primary theme color (HEX or CSS color string)
 * isDefaultStyle: boolean,         // Whether the default style setting is active
 * color: string                    // Computed text or UI color (HEX or CSS color string)
 * }}
 */

export function useDashboardTheme() {
  const { theme } = useTheme();
  const { defaultStyle, primaryColor } = theme;
  // const isDefaultStyle = true;
  const isDefaultStyle = defaultStyle === "true";

  return {
    lineChart: {
      lineColor: primaryColor,
    },
    barChart: {
      barColor: isDefaultStyle ? "#800020" /* maroon color */ : primaryColor,
    },
    // primaryColor_01: `rgba(${hexToRgb(primaryColor)}, 0.1)`,
    primaryColor_01: lightenColor(primaryColor, 0.95),
    primaryColor_02: `rgba(${hexToRgb(primaryColor)}, 0.2)`,
    primaryColor_03: `rgba(${hexToRgb(primaryColor)}, 0.3)`,
    primaryColor_04: `rgba(${hexToRgb(primaryColor)}, 0.4)`,
    primaryColor_05: `rgba(${hexToRgb(primaryColor)}, 0.5)`,
    primaryColor_06: `rgba(${hexToRgb(primaryColor)}, 0.6)`,
    primaryColor_07: `rgba(${hexToRgb(primaryColor)}, 0.7)`,
    primaryColor,
    isDefaultStyle,
    color: isDefaultStyle ? "#2A6CD1" : primaryColor,
    titleColor: primaryColor, // "#7C0124" // "rgba(0, 0, 0, 0.9)",
  };
}
